import TableComponent from '../../Common/Charts/TableCharts';
import { number } from '../../Common/Util/number';
import { useFinancingChartsDataContext } from './hooks/useFinancingChartsDataContext';
import { useSanitizeData } from '../Common/hooks/useSanitizeData';

export const FinancingByChargingReason = () => {
    const { chartData } = useFinancingChartsDataContext();

    const tableColumns = [
        {
            key: 'codigo',
            header: 'Código',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' },
            formatter: (value) => ( <span className="table-badge"> {value} </span> )
        },
        {
            key: 'descricao',
            header: 'Descrição',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'pct',
            header: 'Percentual (%)',
            headerStyle: { fontWeight: '700', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => `${number.formatToBRNumber(value)}%`
        }
    ];

    const rawData = chartData?.byChargingReason || [];

    const sanitizedData = useSanitizeData(rawData);

    return (
        <TableComponent
            className="no-spacing-table"
            data={sanitizedData}
            columns={tableColumns}
            title="Atendimentos por Motivo de Cobrança"
            showTotal={true}
            totalColumn="total"
            formatNumber={number.formatToBRNumber}
            maxHeight="550px"
        />
    );
};
